import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
const ExperimentKitCard: React.FC = () => {
  const scrollToCtaSection = () => {
    const ctaSection = document.getElementById('cta-section');
    if (ctaSection) {
      ctaSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <Card className="border border-neutral-200 shadow-sm overflow-hidden animate-on-scroll">
      <div className="flex flex-col md:flex-row items-start">
        <div className="md:w-2/5 p-4">
          <img src="/images/join-page/experiment-kit-hero.png" alt="Tastermonial Experiment Kit" className="rounded-lg w-full h-auto object-cover" />
        </div>
        <CardContent className="flex-1 p-6">
          <h4 className="text-xl font-bold mb-2">Tastermonial Experiment Kit</h4>

          <div className="flex items-baseline gap-3 mb-4">
            <span className="text-2xl font-bold">$99</span>
            <span className="text-sm text-neutral-600">per kit</span>
          </div>

          <p className="text-sm text-neutral-600 mb-4">Each kit includes a CGM sensor, test products and experiment materials.</p>

          <div className="bg-neutral-50 p-4 rounded-lg mb-4 border border-neutral-100">
            <div className="flex items-start gap-2">
              <Info size={18} className="text-neutral-500 mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-sm text-neutral-700"><strong>Important:</strong> Kit production takes 2 weeks after we receive your product and approved protocol; shipping takes 3–7 business days. Activate CGMs only after your experiment is published.</p>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-2 mt-4">
            <Button onClick={scrollToCtaSection} className="bg-primary hover:bg-primary-700">
              Ask for Bulk Purchases
            </Button>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button variant="outline" className="border-primary text-primary" onClick={() => window.open("https://tastermonial.com/products/blood-sugar-satiety-mastery-plan?variant=46066695798922", "_blank")}>
                    Learn More
                  </Button>
                </TooltipTrigger>
                <TooltipContent>
                  <p>Opens in a new tab</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
        </CardContent>
      </div>
    </Card>;
};
export default ExperimentKitCard;